// based on https://auth0.com/blog/complete-guide-to-react-user-authentication/
import { Auth0Provider } from '@auth0/auth0-react';
import { ReactNode } from 'react';

import { getAuth0Config } from './config';
import { useAuthRedirectCallback } from './useAuthRedirectCallback';

export const Auth0ProviderWithNav = ({ children }: { children: ReactNode | ReactNode[] }): JSX.Element => {
  const { audience, scope, clientId, domain, redirectUri } = getAuth0Config();
  const handleAuthRedirect = useAuthRedirectCallback();

  return (
    <Auth0Provider
      authorizationParams={{ redirect_uri: redirectUri, audience, scope }}
      cacheLocation='localstorage'
      onRedirectCallback={(appState) => {
        handleAuthRedirect({ appState, currentPath: location.pathname });
      }}
      useRefreshTokens
      useRefreshTokensFallback
      clientId={clientId}
      domain={domain}
    >
      {children}
    </Auth0Provider>
  );
};
